import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw0001Handlers = [

  // マークコードリスト取得 /kymw00/getMarkCodeList
  http.post(PlessService.SERVICE.KYMW00getMarkCodeList.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW00getMarkCodeList.url, req);
    return HttpResponse.json(getMarkCodeListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getMarkCodeListResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "MarkCode": "001",
        "MarkName": "９９：表紙掲載",
      },
      {
        "MarkCode": "2",
        "MarkName": "９９：今週のおすすめ",
      },
      {
        "MarkCode": "05",
        "MarkName": "９９：スーパープライス",
      },
      {
        "MarkCode": "006",
        "MarkName": "０１：今週のお買い得",
      },
      {
        "MarkCode": "007",
        "MarkName": "９９：新登場",
      },
      {
        "MarkCode": "010",
        "MarkName": "９９：裏表紙掲載商品",
      },
      {
        "MarkCode": "012",
        "MarkName": "０１：くらし応援",
      },
    ],
  },
};
